import { IGameOptionsGroup } from '@bg-shared/interfaces/IGameOptionsGroup';

export const mapToGroupsIds = (groups: IGameOptionsGroup[]) =>
    groups.map((group) => ({
        id: group.id,
        ids: group.options.map((option) => option.id),
    }));
